export default __webpack_public_path__ + "static/home-f12d55df7d28f34cee79b4fa28aeddfb.gif";